import { render, staticRenderFns } from "./PostalListCustomer.vue?vue&type=template&id=988eb6ac&scoped=true&"
import script from "./PostalListCustomer.vue?vue&type=script&lang=ts&"
export * from "./PostalListCustomer.vue?vue&type=script&lang=ts&"
import style0 from "./PostalListCustomer.vue?vue&type=style&index=0&id=988eb6ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988eb6ac",
  null
  
)

export default component.exports